import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ActividadViewTipoEnum } from 'enums/rutaSesionTipo';

const initialState = ActividadViewTipoEnum.guia;

const selectedCurrentViewActividadSlice = createSlice({
	name: 'selectedCurrentViewActividad',
	initialState,
	reducers: {
		setCurrentViewActividad: (state, action: PayloadAction<ActividadViewTipoEnum>) => {
			return action.payload;
		}
	}
});

export const { setCurrentViewActividad } = selectedCurrentViewActividadSlice.actions;

export default selectedCurrentViewActividadSlice.reducer;
